export var PROFILE_ITEMS_PER_PAGE = 50;